import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import { Box } from "@mui/material";
import { IContactPerson } from "src/types/clients";

const tableHeadText = ["Name", "Position", "Phone number", "Email"];

interface IProps {
  contactPersons: IContactPerson[];
}

const ContactPersons = (props: IProps) => {
  const { contactPersons } = props;
  const noData = contactPersons.length === 0;

  return (
    <Box>
      <TableContainer
        sx={{
          bgcolor: "#1A1A1A",
          boxShadow: "0px 14px 44px 0px rgba(0, 0, 0, 0.35)",
          padding: "30px",
        }}
      >
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {tableHeadText.map((item) => (
                <TableCell
                  key={item}
                  sx={{
                    fontWeight: 600,
                    color: "#A1A5B7",
                  }}
                  align={item === "Actions" ? "right" : "left"}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {false ? (
            <TableLoadingSkeleton rowsLength={4} cellsLength={2} />
          ) : (
            <TableBody>
              {contactPersons.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.position}</TableCell>
                  <TableCell>{row.mobileNumber}</TableCell>
                  <TableCell>{row.email}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {noData && <NoData subtitle="" />}
      </TableContainer>
    </Box>
  );
};
export default ContactPersons;
